/*
 * This file is part of glowingblue/orell-rezensionen.
 *
 * Copyright (c) 2021 Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
import ReviewComposer from '../components/ReviewComposer';
import LogInModal from 'flarum/forum/components/LogInModal';
import type ComposerState from 'flarum/forum/states/ComposerState';
import type DiscussionListState from 'flarum/forum/states/DiscussionListState';
import type Article from 'flarum/orell-articles/models/Article';

export default function (article?: Article, reviewsState?: DiscussionListState): Promise<ComposerState> {
	return new Promise((resolve, reject) => {
		if (app.session.user?.canCreateReviews() ?? false) {
			const ownReview = article?.ownReview();
			let rating: number | undefined;
			if (ownReview && ownReview.isSimple()) {
				rating = ownReview.rating();
			}

			// `autobind` widens the export to `void | typeof ReviewComposer`.
			app.composer.load(ReviewComposer as Exclude<typeof ReviewComposer, void>, {
				user: app.session.user,
				article,
				reviewsState,
				rating,
			});
			app.composer.show();

			return resolve(app.composer);
		} else {
			app.modal.show(LogInModal);

			return reject();
		}
	});
}

export const canStartReview = (): boolean => {
	if (app.session.user) {
		return app.session.user.canCreateReviews();
	} else {
		return app.forum.attribute<boolean>('canStartDiscussion') || !app.session.user;
	}
};
